import { render, staticRenderFns } from "./sky-span.vue?vue&type=template&id=1a2d300c&scoped=true"
import script from "./sky-span.vue?vue&type=script&lang=js"
export * from "./sky-span.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2d300c",
  null
  
)

export default component.exports